import React from 'react'

import './index.less'

export default function LoadingLayout() {
  return <div className="inft-page-loading" />
}
